import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const RspResult = () => {
  return <CommonResult />;
};

export default RspResult;
